import { useSessionLifecycle } from '@/hooks/useSessionLifecycle';

/**
 * Provider component that initializes session lifecycle management.
 * This component should be rendered once near the root of the app,
 * inside the AuthProvider.
 */
export function SessionLifecycleProvider() {
  // Initialize the session lifecycle hook
  useSessionLifecycle();

  // This component doesn't render anything
  return null;
}

export default SessionLifecycleProvider;
